import React from "react";

export default function Message({
  type = "Success",
  message = "Form has been submitted",
  reset,
  micro = false,
}) {
  const [hide, setHide] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => setHide(true), 1000);
    const resetTimer = setTimeout(() => reset(), 1005);
    return () => {
      clearTimeout(timer);
      clearTimeout(resetTimer);
    };
  });

  if (micro) {
    return (
      <div className="transition-opacity duration-1000 ease-out inline-flex">
        <div
          className={`${
            type === "Success" ? "text-green-800" : "text-red-800"
          } items-center leading-none`}
          role="alert">
          <span className="font-semibold text-left flex-auto">{message}</span>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`text-center absolute transition-opacity duration-1000 ease-out ${
        hide ? "opacity-0" : "opacity-1000"
      }`}
      style={{ bottom: 6, left: 0, right: 0 }}>
      <div
        className={`p-2 ${
          type === "Success"
            ? "bg-green-200 text-green-800"
            : "bg-red-200 text-red-800"
        } items-center leading-none lg:rounded-full flex lg:inline-flex`}
        role="alert">
        <span
          className={`flex rounded-full ${
            type === "Success" ? "bg-green-400" : "bg-red-400"
          } uppercase px-2 py-1 text-xs font-bold mr-3`}>
          {type}
        </span>
        <span className="font-semibold mr-2 text-left flex-auto">
          {message}
        </span>
      </div>
    </div>
  );
}
